module.exports = __webpack_public_path__ + "img/output-10.85df4098.png";